import React from "react";

function Footer(){
    return(
        <div className="footer">
            <h4 className="copyright">© 2022 Copyright | All Rights Reserved</h4>
            <h4 className="creator">Made with 💜 by <a href="https://github.com/sayjess" target="_blank" rel="noreferrer">Jess</a></h4>
        </div>
    )

}

export default Footer;